import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MatDialogRef  } from '@angular/material/dialog';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { CartDialogComponent } from '../cart/cart-dialog/cart-dialog.component';
import { SignInUpRedirectComponent } from '../../main-theme/global-theme/pages/sign-in/sign-in-up-redirect/sign-in-up-redirect.component'; // new
import { ApiService } from '../services/api.service';
import { NotificationService } from '../services/notification.service';
import { Observable } from 'rxjs';
import { SubscriptionService } from '../services/subscription.service';
import { PopupComponent } from 'src/app/theme/components/popup/popup.component';
import { isAllowToCreateOrderOrAddProduct } from 'src/app/theme/utils/util-functions';
import { FeatureTags } from '../../types/feature-tags';
import { StoreDetails } from '../../types/sign-in';
import { OpenCartDialogs } from 'src/app/theme/utils/open-cart-dialog';
import { SharedDataService } from '../services/sharedata.service';
import { FocusMonitor } from '@angular/cdk/a11y';
import { ProductDialogComponent } from '../products-carousel/product-dialog/product-dialog.component';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: "app-controls",
    templateUrl: "./controls.component.html",
    styleUrls: ["./controls.component.scss"],
})
export class ControlsComponent implements OnInit, OnDestroy {
    @Input() product;
    @Input() store;
    @Input() type: string;
    @Input() Color: string;
    @Input() fullBtn: boolean = false;
    @Output() onOpenProductDialog: EventEmitter<any> = new EventEmitter();
    localStorageCartProd;
    cartProductIds = [];
    loggedIn = false;
    userDetails = {};
    storeDetails :StoreDetails = <StoreDetails>{};
    dateFormat;
    sub;
    loginSubService;
    featureTags = {};
    enableCartWithoutRegistration:boolean = null;
    public categories = [];
    subService;
    isbutton
    soldOut: boolean = false;
    private destroy$ = new Subject<void>();
    paymentCashOnDelivery:any;
    isbuttonMap: { [productId: number]: boolean } = {};

    constructor(
        public snackBar: MatSnackBar,
        private router: Router,
        private dialog: MatDialog,
        private apiService: ApiService,
        private notification: NotificationService,
        private subscription: SubscriptionService,
        private activatedRoute: ActivatedRoute,
        private openCartDialogs: OpenCartDialogs,
        public sharedDataservice: SharedDataService,        
        private _focusMonitor: FocusMonitor,
    ) {}

    ngOnInit() {
        this.featureTags = JSON.parse(sessionStorage.getItem("featureTags"));
        this.enableCartWithoutRegistration = this.subscription.getCartWithoutRegistrationStatus()
        this.sharedDataservice.cartLoading
        .pipe(takeUntil(this.destroy$))
        .subscribe(data =>{            
            this.isbutton = data
        })

        if (!!this.product['product']['stock_info'] && this.product['product']['stock_info']['restrict_orders'] == 1 && this.product['product']['stock_info']['stock_in_hand']==0) {
            this.soldOut = true;
        }
        if (
            this.activatedRoute.snapshot["data"]["userDetails"] &&
            this.activatedRoute.snapshot["data"]["userDetails"]["response"][
                "status"
            ] === 1
        ) {
            this.userDetails =
                this.activatedRoute.snapshot["data"]["userDetails"]["response"][
                    "data"
                ]["users"];
        }
        // if (this.activatedRoute.snapshot['data']['store']) {
        this.storeDetails = this.store;
        if (this.storeDetails && this.storeDetails["date_format"] === "m/d/Y") {
            this.dateFormat = "MM/dd/yyyy";
        } else {
            this.dateFormat = "dd/MM/yyyy";
        }
        // }

        if (sessionStorage.getItem("cart") !== "") {
            if (
                JSON.parse(sessionStorage.getItem("cart")) !== null &&
                JSON.parse(sessionStorage.getItem("cart")).length > 0
            ) {
                this.getLocalStorage();
            }
        }
        this.loggedIn = this.apiService.loggedIn();
        this.loginSubService = this.apiService
            .getLogin()
            .pipe(takeUntil(this.destroy$))
            .subscribe((message) => {
                if (message) {
                    this.loggedIn = message["loggedIn"];
                }
            });
        this.sub = this.subscription.getSubject()
        .pipe(takeUntil(this.destroy$))
        .subscribe((message) => {
            if (message["control"]) {
                if (
                    this.product["product"]["id"] ===
                    message["product"]["product"]["id"]
                ) {
                    message["product"]["msg"] = 1;
                    this.cartProductIds = this.localStorageCartProd.map(
                        (val) => {
                            return val["product"]["id"];
                        }
                    );
                    const index = this.cartProductIds.indexOf(
                        message["product"]["product"]["id"]
                    );
                    this.cartProductIds.splice(index, 1);
                    this.product = message["product"];
                }
            }
        });
        this.subService = this.subscription.getSubject()
        .pipe(takeUntil(this.destroy$))
        .subscribe(val => {
            
            if (val['categories']) {
              this.categories = val['categories'].filter(val => val['id'] !== -1);
            }
            
        });
        if (!!this.featureTags && this.featureTags['ftag_cod_and_other_payment_for_sf']) {
            this.paymentCashOnDelivery = this.activatedRoute.snapshot['data']['store']['response']['data']['payment_method_details'][0];
        }
          
    }
    ngOnDestroy() {
        !!this.sub && this.sub.unsubscribe();
        !!this.loginSubService && !!this.loginSubService.unsubscribe();
        this.destroy$.next();
        this.destroy$.complete();
    }

    public getUserDetails() {
        this.apiService.getAutheticatedUserDetails()
        .pipe(takeUntil(this.destroy$))
        .subscribe(data => {
          if (data['response']['status'] === 1) {
            this.userDetails = data['response']['data']['users'];
            if (!!this.featureTags && this.featureTags['ftag_cod_and_other_payment_for_sf']) {
            this.isbuttonMap[this.product["product"]["id"]] = false;
            }
          }
        }, err => { })
    }

    public redirectWithReturnUrl(membershipPoduct?:any): boolean {
        try {
            if (this.apiService.loggedIn() === false) {
                if (!!this.featureTags && this.featureTags['sf_enhance_registration']) {
                    if (!!membershipPoduct) { 
                        this.router.navigate(['/sign-up']);
                        this.sharedDataservice.setRedirectToMembership(true);
                    } else {                        
                        this.sharedDataservice.setRedirectToMembership(false);
                        if (!!this.featureTags && this.featureTags['welcome_checkout_popup_issue']) {
                        const dialogRedirect = this.dialog.open(
                            SignInUpRedirectComponent,
                            {
                                width: "450px",
                                panelClass: ["product-dialog", "product-dailog-style"],
                                data: { membershipPoduct: membershipPoduct },
                            }
                        );

                        dialogRedirect.afterClosed()
                            .pipe(takeUntil(this.destroy$))
                            .subscribe((result) => {
                                if (!!this.featureTags && this.featureTags['pdp_button_color_change']) {
                                    setTimeout(() => {
                                        const Button = document.getElementById('addToCartFullbtn');
                                        if (Button) {
                                            this._focusMonitor.stopMonitoring(Button);
                                        }
                                    }, 0);
                                }
                                if (result) {
                                    this.subscription.setEmitCloseDialogueSubjectNext();
                                }
                            });

                        return true;
                    } else {
                        const dialogRedirect = this.dialog.open(
                            SignInUpRedirectComponent,
                            {
                                width: "450px",
                                panelClass: "product-dialog",
                                data: {},
                            }
                        );

                        dialogRedirect.afterClosed()
                            .pipe(takeUntil(this.destroy$))
                            .subscribe((result) => {
                                if (!!this.featureTags && this.featureTags['pdp_button_color_change']) {
                                    setTimeout(() => {
                                        const Button = document.getElementById('addToCartFullbtn');
                                        if (Button) {
                                            this._focusMonitor.stopMonitoring(Button);
                                        }
                                    }, 0);
                                }
                                if (result) {
                                    this.subscription.setEmitCloseDialogueSubjectNext();
                                }
                            });

                        return true;
                    }
                    }
                } else {
                    if (!!this.featureTags && this.featureTags['welcome_checkout_popup_issue']) {
                        const dialogRedirect = this.dialog.open(
                            SignInUpRedirectComponent,
                            {
                                width: "450px",
                                panelClass: ["product-dialog", "product-dailog-style"],
                                data: { membershipPoduct: membershipPoduct },
                            }
                        );

                        dialogRedirect.afterClosed()
                            .pipe(takeUntil(this.destroy$))
                            .subscribe((result) => {
                                if (!!this.featureTags && this.featureTags['pdp_button_color_change']) {
                                    setTimeout(() => {
                                        const Button = document.getElementById('addToCartFullbtn');
                                        if (Button) {
                                            this._focusMonitor.stopMonitoring(Button);
                                        }
                                    }, 0);
                                }
                                if (result) {
                                    this.subscription.setEmitCloseDialogueSubjectNext();
                                }
                            });

                        return true;
                    } else {
                        const dialogRedirect = this.dialog.open(
                            SignInUpRedirectComponent,
                            {
                                width: "450px",
                                panelClass: "product-dialog",
                                data: {},
                            }
                        );

                        dialogRedirect.afterClosed()
                            .pipe(takeUntil(this.destroy$))
                            .subscribe((result) => {
                                if (!!this.featureTags && this.featureTags['pdp_button_color_change']) {
                                    setTimeout(() => {
                                        const Button = document.getElementById('addToCartFullbtn');
                                        if (Button) {
                                            this._focusMonitor.stopMonitoring(Button);
                                        }
                                    }, 0);
                                }
                                if (result) {
                                    this.subscription.setEmitCloseDialogueSubjectNext();
                                }
                            });

                        return true;
                    }
                }
            }
            else {
                return false;
            }
        } catch (error) {
            console.log(error);
        }
    }


    public addToCart(product) {
        if (!!this.featureTags && this.featureTags['ftag_allow_product_to_customer_based_events']) {
            if (this.apiService.loggedIn() === true) {
                let user_event_ids = JSON.parse(sessionStorage.getItem('user_event_ids'));
                if (!!product.product['product_event_ids'] && !!user_event_ids &&  (product.product['product_event_ids'].some((eventId: number) => user_event_ids.map(String).includes(String(eventId))))) {
                    const dialogRef = this.dialog.open(PopupComponent, {
                        maxWidth: '96vw',
                        width: '450px',
                        data: { msg: 'This product cannot be ordered for your pickup location or route.',
                                restrict_product : true
                              }
                    });
                    return;
                }
            }
          }
        if (!!this.featureTags && this.featureTags['ftags_membership']) {
            if (product.product.type === "membership") {
                  if (!!this.featureTags && this.featureTags['ftag_cod_and_other_payment_for_sf']) {
                      if (this.apiService.loggedIn() == true) {
                          if (this.userDetails['preferred_payment_method'] === 'Credit Card') {
                              this.apiService.getCreditCardList().subscribe(data => {
                                  if (data['response']['status'] == 6) {
                                      this.subscription.behSubjectNext({ orderMsg: 'Credit card Not Found' });
                                      
                                      const dialogRef = this.dialog.open(PopupComponent, {
                                          maxWidth: '96vw',
                                          width: '450px',
                                          data: { 
                                              msg: this.paymentCashOnDelivery.is_sf_active === 1 
                                                  ? 'Cash On Delivery' 
                                                  : 'Credit card Not Found',
                                              type: product.product.type
                                          }
                                      });
                                       dialogRef.afterClosed().subscribe(result => {
                                          if (result == 'Pay Later') {
                                            this.getUserDetails();
                                              sessionStorage.setItem("membership_item", JSON.stringify(product));
                                              this.router.navigate(['/membership-purchase']);
                                              if (this.dialog.openDialogs.length > 0) {
                                                  this.dialog.closeAll();
                                              }
                                              this.isbuttonMap[product["product"]["id"]] = true;
                                              
                                          }
                                      });
                                      return;
                                  } else {
                                      sessionStorage.setItem("membership_item", JSON.stringify(product));
                                      this.router.navigate(['/membership-purchase']);
                                      if (this.dialog.openDialogs.length > 0) {
                                          this.dialog.closeAll();
                                        }
                                  }
                              });
                          } else {
                                  if (this.userDetails['preferred_payment_method'] === 'Cash On Delivery') {
                                      if (this.apiService.loggedIn() == true) {
                                          sessionStorage.setItem("membership_item", JSON.stringify(product));
                                          this.router.navigate(['/membership-purchase']);
                                          if (this.dialog.openDialogs.length > 0) {
                                              this.dialog.closeAll();
                                          }
                                      } else {
                                          sessionStorage.setItem("membership_item", JSON.stringify(product));
                                          if (!!this.redirectWithReturnUrl('membershipPoduct')) {
                                              return;
                                          }
                                      }
                                  } else {
                                      const dialogRef = this.dialog.open(PopupComponent, {
                                          maxWidth: '96vw',
                                          width: '450px',
                                          data: { msg: 'Cash On Delivery' }
                                      });
                                      dialogRef.afterClosed().subscribe(result => {
                                          if (result == true) {
                                              this.router.navigate(['/account/payment']);
                                              if (this.dialog.openDialogs.length > 0) {
                                                  this.dialog.closeAll();
                                              }
                                          }
                                      });
                                  }

                          }
                      } else {
                          sessionStorage.setItem("membership_item", JSON.stringify(product));
                          if (!!this.redirectWithReturnUrl('membershipPoduct')) {
                              return;
                          }
                      }
                
                } else {
                    this.apiService.getCreditCardList().subscribe(data => {
                        if (data['response']['status'] == 6) {
                            this.subscription.behSubjectNext({ orderMsg: 'Credit card Not Found' });
                            const dialogRef = this.dialog.open(PopupComponent, {
                                maxWidth: '96vw',
                                width: '450px',
                                data: { msg: 'Credit card Not Found' }
                            });
                            return;
                        }else{
                            if(this.apiService.loggedIn() == true) {
                                sessionStorage.setItem("membership_item", JSON.stringify(product));
                                this.router.navigate(['/membership-purchase']);
                                if (this.dialog.openDialogs.length > 0) {
                                    this.dialog.closeAll();
                                }
                            }else{
                                sessionStorage.setItem("membership_item", JSON.stringify(product));
                                if (!!this.redirectWithReturnUrl('membershipPoduct')) {
                                    return;
                                }
                            }
                        }
                    });
                }
                return;
            }
        }
        // if check allow to create order (OR) add product start
        // if (!!this.featureTags?.["enable_disable_cart_without_registration"]) {            
            try {
                if (!this.enableCartWithoutRegistration) {
              
                    if (!!this.redirectWithReturnUrl()) {
                        return;
                    }
                }
            } catch (error) {
                console.log(error);
            }
        // }

        if (this.apiService.loggedIn()) {
            if (
                !isAllowToCreateOrderOrAddProduct(this.dialog, PopupComponent, {
                    yesBtn: true,
                    noBtn: false,
                })
            ) {
                return;
            }
        }
        this.sharedDataservice.productDialog$.next(true);
        // if check allow to create order (OR) add product end
        product["msg"] = 2;
        if (this.storeDetails) {
            product["storeDetails"] = this.store;
        }
        const dialogRef = this.dialog.open(CartDialogComponent, {
            width: "450px",
            panelClass: "product-dialog",
            data: product,
        });
        dialogRef.afterClosed()
        .pipe(takeUntil(this.destroy$))
        .subscribe((result) => {
            if (result) {
                if (
                    result["value"] === "confirm" &&
                    result["logged"] === "no"
                ) {
                    this.getLocalStorage();
                    this.subscription.subjectNext({
                        msg: "get shopping cart status bar data",
                        closeProducDialog: true,
                        refresh: true,
                    });
                }
                if (
                    result["value"] === "confirm" &&
                    result["logged"] === "yes"
                ) {
                    // result['product']['cart']['recurring'] = 0;
                    // product = result['product'];
                    this.subscription.subjectNext({
                        refresh: true,
                        closeProducDialog: true,
                    });
                    // this.subscription.subjectNext({msg: "get shopping cart status bar data"});
                }
            }
            if (!!this.featureTags && this.featureTags['pdp_button_color_change']) {
                setTimeout(() => {
                    const Button = document.getElementById('addToCartFullbtn');
                    if (Button) {
                        this._focusMonitor.stopMonitoring(Button);
                    }
                }, 0);
            }
        });
    }
    editCart(product) {
        // if (!!this.featureTags?.["enable_disable_cart_without_registration"]) {
            try {
                if (!this.enableCartWithoutRegistration) {
                    if (!!this.redirectWithReturnUrl()) {
                        return;
                    }
                }
            } catch (error) {
                console.log(error);
            }
        // }

        // if check allow to create order (OR) add product start
        if (this.apiService.loggedIn()) {
            if (
                !isAllowToCreateOrderOrAddProduct(this.dialog, PopupComponent, {
                    yesBtn: true,
                    noBtn: false,
                })
            ) {
                return;
            }
        }
        // if check allow to create order (OR) add product end
        var value;
        if (this.loggedIn === true) {
            product["msg"] = 2;
            value = product;
        }
        if (this.loggedIn === false) {
            const cartData = JSON.parse(sessionStorage.getItem("cart"));
            var newproductValue = cartData.filter(
                (val) => val["product"]["id"] === product["product"]["id"]
            );
            value = {};
            newproductValue[0]["msg"] = 1;
            value = newproductValue[0];
        }
        if (this.storeDetails) {
            value["storeDetails"] = this.store;
        }
        const dialogRef = this.dialog.open(CartDialogComponent, {
            width: "450px",
            panelClass: "product-dialog",
            data: value,
        });
        dialogRef.afterClosed()
        .pipe(takeUntil(this.destroy$))
        .subscribe((result) => {
            if (result) {
                if (
                    result["value"] === "confirm" &&
                    result["logged"] === "no"
                ) {
                    this.getLocalStorage();
                    this.subscription.subjectNext({
                        msg: "get shopping cart status bar data",
                    });
                }
                if (
                    result["value"] === "confirm" &&
                    result["logged"] === "yes"
                ) {
                    this.subscription.subjectNext({ refresh: true });
                }
            }
            if (!!this.featureTags && this.featureTags['pdp_button_color_change']) {
                setTimeout(() => {
                    const Button = document.getElementById('editFullBtn');
                    if (Button) {
                        this._focusMonitor.stopMonitoring(Button);
                    }
                }, 0);
            }
        });
    }
    recurring(product) {
        console.log(product);
        
        // if check allow to create order (OR) add product start
        if (this.apiService.loggedIn()) {
            if (
                !isAllowToCreateOrderOrAddProduct(this.dialog, PopupComponent, {
                    yesBtn: true,
                    noBtn: false,
                })
            ) {
                return;
            }
        }
        // if check allow to create order (OR) add product end
        product["msg"] = 2;
        product["currency"] = this.storeDetails["currency"];
        product["deliveryDay"] = this.userDetails["delivery_day"];
        product["date-format"] = this.dateFormat;
        const dialogRef = this.dialog.open(PopupComponent, {
            maxWidth: "90vw",
            width: "360px",
            panelClass: "product-dialog",
            data: {
                data: product,
                msg: "edit subscription from products",
            },
        });
        dialogRef.afterClosed()
        .pipe(takeUntil(this.destroy$))
        .subscribe(() => {  
                if (!!this.featureTags && this.featureTags['pdp_button_color_change']) {
                setTimeout(() => {
                    const recurringButton = document.getElementById('recurringFullBtn');
                    if (recurringButton) {
                        this._focusMonitor.stopMonitoring(recurringButton);                    
                    }
                }, 0);
                }
            });
    }
    public openProductDialog(event) {
        // console.log(event);
        this.onOpenProductDialog.emit(event);
    }

    getLocalStorage() {
        this.localStorageCartProd = JSON.parse(sessionStorage.getItem("cart"));
        this.cartProductIds = this.localStorageCartProd.map((val) => {
            return val["product"]["id"];
        });
        this.subscription.subjectNext({
            cartlength: this.cartProductIds.length,
        });
    }
    goToProduct(product) {
        var description = product['product']['description'].replace('&amp;', '&');
        if (this.router.url.includes('categories')) {
          var parentCategory = this.categories.find(val => val['category_url'] === product['product']['cb_category']['url']);
    
          if (!!parentCategory === false) {
            var parent = this.categories.find(val => {
              return val['sub_list'].some(sub => {
                return sub['category_url'] === product['product']['cb_category']['url']
              });
            });
            if (product['product']['website_url']) {
              // this.router.navigate(['/categories', parent['category_url'], product['product']['cb_category']['url'], product['product']['website_url']]);
            //   this.router.navigate(['/product',  product['product']['website_url']]);
              var url= '/products' + '/'+  product['product']['website_url'];
              window.open(url);
            } else {
              // this.router.navigate(['/categories', parent['category_url'], product['product']['cb_category']['url'], product['product']['id']]);
            //   this.router.navigate(['/products',  product['product']['id']]);
            var url= '/products' + '/'+  product['product']['id'];
            window.open(url);
            }
          } else {
            if (product['product']['website_url']) {
            // this.router.navigate(['/categories', parentCategory['category_url'], product['product']['website_url']]);
            // this.router.navigate(['/products',  product['product']['website_url']]);
            var url= '/products' + '/'+  product['product']['website_url'];
            window.open(url);
            }else{
            // this.router.navigate(['/categories', parentCategory['category_url'], product['product']['id']]);
            // this.router.navigate(['/products',  product['product']['id']]);
            var url= '/products' + '/'+  product['product']['id'];
            window.open(url);
            }
          }
        } else if (this.router.url.includes('vendors')) {
        //   if(this.featureTags['enable_individual_products_page']){
            var parentCategory = this.categories.find(val => val['category_url'] === product['product']['cb_category']['url']);
            if (!!parentCategory === false) {
              var parent = this.categories.find(val => {
                return val['sub_list'].some(sub => {
                  return sub['category_url'] === product['product']['cb_category']['url']
                });
              });
              if (product['product']['website_url']) {
                // this.router.navigate(['/vendors', parent['category_url'], product['product']['cb_category']['url'], product['product']['website_url']]);
                // this.router.navigate(['/products', product['product']['website_url']]);
                var url= '/products' + '/'+  product['product']['website_url'];
                window.open(url);
              } else {
                // this.router.navigate(['/vendors', parent['category_url'], product['product']['cb_category']['url'], product['product']['id']]);
                // this.router.navigate(['/products', product['product']['id']]);
                var url= '/products' + '/'+  product['product']['id'];
                window.open(url);
              }  
          }
        //   } else {
        //     if (product['product']['website_url']) {
        //       // this.router.navigate(['/vendors', this.params['parentCategory'], this.params['subCategory'], product['product']['website_url']]);
        //     //   this.router.navigate(['/products', product['product']['website_url']]);
        //     var url= '/products' + '/'+  product['product']['website_url'];
        //     window.open(url);
        //     } else {
        //       // this.router.navigate(['/vendors', this.params['parentCategory'], this.params['subCategory'], product['product']['id']]);
        //     //   this.router.navigate(['/products',  product['product']['id']]);
        //     var url= '/products' + '/'+  product['product']['id'];
        //     window.open(url);
        //     }
        //   }      
        // } else if (this.router.url.includes('search') || this.router.url.includes('all-products')) {
        } else if (this.router.url.includes('search') || this.router.url.includes('products')) {
            if (product['product']['website_url']) {
                //   this.router.navigate(['/products', product['product']['website_url']]);
                var url = '/products' + '/' + product['product']['website_url'];
                window.open(url);
            } else {
                //   this.router.navigate(['/products', product['product']['id']]);
                var url = '/products' + '/' + product['product']['id'];
                window.open(url);
            }
        } else if (this.router.url.includes('home')) {
            if (product['product']['website_url']) {
                var url = '/products' + '/' + product['product']['website_url'];
                window.open(url);
            } else {
                var url = '/products' + '/' + product['product']['id'];
                window.open(url);
            }
        }
    
        // if(value === 'subCat' && this.router.url.split('/').length === 4 && this.router.url.includes('categories')) {
        //   this.router.navigate(['/categories', this.params['parentCategory'], this.params['subCategory'] , description.replace(/[\s&()%/]+/g, '-') , product['product']['id']]);
        // } else if (value === 'parent' && this.router.url.includes('categories')) {
        //   if(this.router.url.split('/').length > 4) {
        //     this.router.navigate(['/categories', this.params['parentCategory'], this.params['subCategory'], description.replace(/[\s&()%/]+/g, '-') , product['product']['id']]);
        //   } else {
        //     this.router.navigate(['/categories', this.params['parentCategory'], description.replace(/[\s&()%/]+/g, '-') , product['product']['id']]);
        //   }
        // } 
      }
}